import React from "react";
import SelectGender from "../SelectGender";
import SelectTalent from "../SelectTalent";
import SelectCourses from "../SelectCourses";
import SelectYear from "../SelectYear";
import SelectMonth from "../SelectMonth";
import SelectCities from "../SelectCities";
import SelectCountries from "../SelectCountries";

export default function NavbarUserFiltersModal({
  closeModal,
  onValue,
  filter_course_value,
  filter_talent_value,
  filter_gender_value,
  filter_from_year_value,
  filter_from_month_value,
  filter_to_year_value,
  filter_to_month_value,
  filter_birth_country_value,
  filter_birth_city_value,
  filter_living_country_value,
  filter_living_city_value,
}) {
  return (
    <div className="modal-content">
     
      <div className="modal-body">
        <div className="filters">
          <div className="box box-primary" >
            <form action="users" className="form-horizontal">
              <div className="box-body padding-10 modal-sm-overflow">
                <div className="mb-10">
                  <div className="col-md-12 padding-l-0 ">
                    <div className="col-md-4 padding-0 mb-10 padding-r-5">
                      <input
                        type="text"
                        name="first_name"
                        className="form-control"
                        placeholder="First Name"
                      />
                    </div>
                    <div className="col-md-4 padding-0 mb-10   padding-r-5 ">
                      <input
                        type="text"
                        name="last_name"
                        className="form-control"
                        placeholder="Last Name"
                      />
                    </div>
                    <div className="col-md-4 mb-10  padding-0 ">
                      <SelectGender
                        width="130px"
                        border="1"
                        value={filter_gender_value}
                        callback={onValue}
                      />
                      <input type="hidden" name="gender" value={filter_gender_value} />
                      <div className="clear"></div>
                    </div>
                    <div className="col-md-12 padding-0">
                      <div className="pull-left margin-r-10 mb-10 padding-0">
                        <SelectTalent
                          value={filter_talent_value}
                          width="280px"
                          border="1"
                          callback={onValue}
                        />
                        <input type="hidden" name="talent" value={filter_talent_value} />
                      </div>
                      <div className="pull-left margin-r-10 mb-10 padding-0">
                        <SelectCourses
                          value={filter_course_value}
                          width="200px"
                          border="1"
                          callback={onValue}
                        />
                        <input type="hidden" name="course" value={filter_course_value} />
                      </div>
                    </div>
                    <div className="clear"></div>
                  </div>
                  <div className="col-md-12  padding-10">
                    <div className="row">
                      <label className="col-lg-12 text-left">Date of Birth</label>
                      <div className="col-lg-6 col-sm-12 padding-r-0 ">
                        <label className="col-lg-12 padding-0  text-left">From</label>
                        <div className="col-lg-12  padding-0">
                          <div className="pull-left">
                            <SelectYear
                              value={filter_from_year_value}
                              name="from_year"
                              width="120px"
                              border="1"
                              callback={onValue}
                            />
                            <input
                              type="hidden"
                              name="from_year"
                              value={filter_from_year_value}
                            />
                          </div>
                          <div className="pull-left margin-l-5">
                            <SelectMonth
                              value={filter_from_month_value}
                              name="from_month"
                              width="120px"
                              border="1"
                              callback={onValue}
                            />
                            <input
                              type="hidden"
                              name="from_month"
                              value={filter_from_month_value}
                            />
                          </div>
                        </div>
                        <div className="clear"></div>
                      </div>
                      <div className="col-lg-6  col-sm-12 padding-r-0">
                        <label className="col-lg-12 padding-0  text-left">To</label>
                        <div className="col-lg-12 padding-0">
                          <div className="pull-left">
                            <SelectYear
                              value={filter_to_year_value}
                              name="to_year"
                              width="120px"
                              border="1"
                              callback={onValue}
                            />
                            <input type="hidden" name="to_year" value={filter_to_year_value} />
                          </div>
                          <div className="pull-left margin-l-5">
                            <SelectMonth
                              value={filter_to_month_value}
                              name="to_month"
                              width="120px"
                              border="1"
                              callback={onValue}
                            />
                            <input type="hidden" name="to_month" value={filter_to_month_value} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="clear"></div>
                </div>
                <div className="">
                  <div className="col-md-6 padding-10">
                    <div className="col-md-12 padding-0 text-left">
                      <label>Born in</label>
                    </div>
                    <div className="pull-left margin-r-10 mb-10">
                      <SelectCountries
                        kurds={1}
                        value={filter_birth_country_value}
                        name="country"
                        width="180px"
                        border="1"
                        callback={onValue}
                      />
                      <input type="hidden" name="country" value={filter_birth_country_value} />
                    </div>
                    <div className="pull-left ">
                      <SelectCities
                        country={filter_birth_country_value}
                        key={filter_birth_country_value}
                        value={filter_birth_city_value}
                        name="city"
                        width="180px"
                        border="1"
                        callback={onValue}
                      />
                      <input type="hidden" name="city" value={filter_birth_city_value} />
                    </div>
                    <div className="clear"></div>
                  </div>
                  <div className="col-md-6  padding-0 ">
                    <div className="padding-10 padding-l-5 ">
                      <div className="col-md-12 padding-0 text-left">
                        <label>Living in</label>
                      </div>
                      <div className="pull-left margin-r-10 mb-10 ">
                        <SelectCountries
                          value={filter_living_country_value}
                          name="living_country"
                          width="180px"
                          border="1"
                          callback={onValue}
                        />
                        <input
                          type="hidden"
                          name="living_country"
                          value={filter_living_country_value}
                        />
                      </div>
                      <div className="pull-left ">
                        <SelectCities
                          country={filter_living_country_value}
                          key={filter_living_country_value}
                          value={filter_living_city_value}
                          name="living_city"
                          width="180px"
                          border="1"
                          callback={onValue}
                        />
                        <input type="hidden" name="living_city" value={filter_living_city_value} />
                      </div>
                      <div className="clear"></div>
                    </div>
                    <div className="clear"></div>
                  </div>
                  <div className="clear"></div>
                </div>
              </div>
              <div className="box-footer">
                <button type="submit" className="btn btn-primary pull-right">
                  Filter
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
